import React from 'react';
import { Typography } from 'antd';
import { FileOutlined, DownloadOutlined } from '@ant-design/icons';
import { IFile } from '../../../../types/files';
import { questionCardStyles } from '../../styles/questionCard';

const { Text } = Typography;

interface FilesDisplayProps {
  files: IFile[];
  comment?: string;
}

const FilesDisplay: React.FC<FilesDisplayProps> = ({ files, comment }) => {
  const handleFileClick = (fileUrl: string) => {
    window.open(fileUrl, '_blank');
  };

  return (
    <div style={questionCardStyles.filesContainer}>
      {/* <Text type="secondary" style={questionCardStyles.filesLabel}>
        Files ({files.length}):
      </Text> */}

      <div style={questionCardStyles.filesList}>
        {files.map((file, index) => (
          <button
            key={index}
            aria-label={`Download file ${file.name}`}
            onClick={() => handleFileClick(file.url)}
            className={questionCardStyles.fileItemWithHover}>
            <FileOutlined style={questionCardStyles.fileIcon} />
            <div style={questionCardStyles.fileContent}>
              <Text style={questionCardStyles.fileName}>{file.name}</Text>
              {file.size && (
                <Text style={questionCardStyles.fileSize}>{(file.size / 1024).toFixed(1)} KB</Text>
              )}
            </div>
            <DownloadOutlined style={questionCardStyles.fileDownloadIcon} />
          </button>
        ))}
      </div>

      {comment && <Text style={questionCardStyles.fileComment}>{comment}</Text>}
    </div>
  );
};

export default FilesDisplay;
